import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chart-pie",
  "use": "icon-chart-pie-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chart-pie\"><path fill=\"currentColor\" d=\"M475.456686 73.151909v455.87143c0 10.751987 8.767989 19.583976 19.583975 19.583975h455.80743a475.519406 475.519406 0 0 1-505.727367 474.431407c-236.799704-14.719982-429.439463-207.359741-444.159445-444.159445a475.519406 475.519406 0 0 1 474.495407-505.727367zM527.040621 0A496.959379 496.959379 0 0 1 1024 497.023379H547.520596a20.479974 20.479974 0 0 1-20.479975-20.479975z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol